<template>
  <div id="get-travel-inspired" v-if="stories && stories.length > 0">
    <p>Get travel inspired</p>
    <b-row>
      <b-col
        v-for="(story, index) in stories"
        :key="story.id"
        :cols="index < 1 ? '12' : '6'"
      >
        <div
          @click="openPopup(story.id)"
          class="inspired"
          :style="{
            backgroundImage: story.thumbnailUrl
              ? `url(${story.thumbnailUrl})`
              : '',
          }"
        >
          <div class="story-title">{{ story.title }}</div>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import axios from "axios";
import StoryService from "@/services/story";

export default {
  name: "get-travel-inspired",
  props: {
    travelerTypes: {
      type: Array,
      default: () => [],
    },
    locations: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      stories: [],
      final: false,
    };
  },
  mounted() {
    this.load();
  },
  methods: {
    load() {
      const url = process.env.VUE_APP_API_URI;
      const postData = {
        query: `query stories($travelerTypes: [ID], $locations: [ID]) { stories(travelerTypes: $travelerTypes, locations: $locations) { final data { id title name thumbnailUrl }} }`,
        variables: {
          travelerTypes: this.travelerTypes,
          locations: this.locations
        }
      };
      axios
        .post(url, postData, {
          headers: {
            "X-API-Key": process.env.VUE_APP_API_KEY,
          },
        })
        .then((res) => {
          const stories = res.data.data.stories;
          this.stories = stories.data;
          this.final = stories.final;
        })
        .catch(console.error);
    },
    openPopup(id) {
      StoryService.openPopup(id);
    },
  },
};
</script>

<style lang="scss" scoped>
#get-travel-inspired {
  padding: 0 22px 30px;

  .inspired {
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    height: 145.46px;
    margin-bottom: 15px;
    position: relative;
    display: block;

    .story-title {
      color: #fff;
      text-shadow: 0 2px 3px rgba(0, 0, 0, 0.16);
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      width: 100%;
      padding: 5px;
      text-align: center;
      background-image: linear-gradient(
        to bottom,
        rgba(0, 0, 0, 0),
        rgba(0, 0, 0, 0.75)
      );
    }
  }
}
</style>
